// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__23GVP","buttons":"RemoveExpirationActionButtons_buttons__2KlMg"};